(function () {
  var dataEl = document.getElementById('variant-metafields-data');
  if (!dataEl) return;

  var allVariantData;
  try {
    allVariantData = JSON.parse(dataEl.textContent);
  } catch (e) { return; }

  var LENS_LABELS = {
    lens_polarisation: 'Polarisation',
    lens_colour: 'Colour',
    lens_category: 'Category',
    lens_material: 'Material',
    lens_gradient: 'Gradient',
    mirror: 'Mirror'
  };
  var FRAME_LABELS = {
    frame_colour: 'Colour',
    frame_finish: 'Finish',
    frame_transparency: 'Transparency',
    photochromatic: 'Photochromatic',
    coatings: 'Coatings',
    uv_protection: 'UV Protection'
  };

  function formatValue(key, value) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (value === 'true') return 'Yes';
    if (value === 'false') return 'No';
    if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : null;
    return String(value);
  }

  function populateList(listEl, labels, data) {
    listEl.innerHTML = '';
    var hasAny = false;
    Object.keys(labels).forEach(function (key) {
      var val = formatValue(key, data[key]);
      if (!val) return;
      if ((key === 'lens_gradient' || key === 'photochromatic') && (val === 'No' || val === 'false')) return;
      hasAny = true;
      var div = document.createElement('div');
      div.className = 'variant-specs__row';
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = labels[key];
      dd.textContent = val;
      div.appendChild(dt);
      div.appendChild(dd);
      listEl.appendChild(div);
    });
    return hasAny;
  }

  function updateDetails(variantId) {
    var wrapper = document.getElementById('variant-specs');
    var lensGroup = document.getElementById('variant-specs-lens');
    var frameGroup = document.getElementById('variant-specs-frame');
    var lensList = document.getElementById('variant-specs-lens-list');
    var frameList = document.getElementById('variant-specs-frame-list');
    if (!wrapper || !lensList || !frameList) return;
    var data = allVariantData[String(variantId)];
    if (!data) { wrapper.style.display = 'none'; return; }
    var hasLens = populateList(lensList, LENS_LABELS, data);
    var hasFrame = populateList(frameList, FRAME_LABELS, data);
    lensGroup.className = 'variant-specs__group' + (hasLens ? '' : ' variant-specs__group--empty');
    frameGroup.className = 'variant-specs__group' + (hasFrame ? '' : ' variant-specs__group--empty');
    wrapper.style.display = (hasLens || hasFrame) ? 'block' : 'none';
  }

  // Get variant ID from URL first, then form input, then first key in data
  function getVariantIdFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant') || null;
  }

  function getVariantIdFromForm() {
    var selectors = [
      'form[action="/cart/add"] input[name="id"]',
      'form[action*="cart/add"] input[name="id"]',
      '.product-form input[name="id"]',
      'input[name="id"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.value) return el.value;
    }
    return null;
  }

  function getBestVariantId() {
    // URL is the most reliable source — Showcase updates it on every variant switch
    return getVariantIdFromUrl() || getVariantIdFromForm() || Object.keys(allVariantData)[0];
  }

  var lastVariantId = null;

  function checkAndUpdate() {
    var id = getBestVariantId();
    if (id && String(id) !== String(lastVariantId)) {
      lastVariantId = String(id);
      updateDetails(id);
    }
  }

  // Poll URL and form every 200ms — covers all Showcase variant switching mechanisms
  setInterval(checkAndUpdate, 200);

  // Also catch theme-level events for instant response
  document.addEventListener('theme:variant-change', function (e) {
    var id = e.detail && e.detail.variant && e.detail.variant.id;
    if (id) { lastVariantId = String(id); updateDetails(String(id)); }
  });
  document.addEventListener('variant:changed', function (e) {
    var id = e.detail && e.detail.variant && e.detail.variant.id;
    if (id) { lastVariantId = String(id); updateDetails(String(id)); }
  });

  // Listen for clicks on variant swatches/options — re-check after Showcase updates URL
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (el.closest && (
      el.closest('.clickyboxes') ||
      el.closest('.variant-option') ||
      el.closest('.option-selector') ||
      el.tagName === 'LABEL'
    )) {
      // Showcase updates URL shortly after click — check after a brief delay
      setTimeout(checkAndUpdate, 100);
      setTimeout(checkAndUpdate, 400);
    }
  });

  // Initial load
  function init() {
    checkAndUpdate();
    if (lastVariantId === null) {
      // Retry if nothing found yet
      setTimeout(checkAndUpdate, 150);
      setTimeout(checkAndUpdate, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
